module.exports = __webpack_public_path__ + "word_map.png?925633f6715929c667b2541eb7dad40e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/inspinia/img/landing/word_map.png
// module id = 616
// module chunks = 0